import { NgModule } from '@angular/core';

import { ChatApiService } from './chat-api.service';

@NgModule({
  providers: [ChatApiService]
})
export class ChatApiModule {}
